(function () {
  'use strict';

  var COHORT = 'CF_DIY_MARINE_V1';
  var PATHS = ['marine_vinyl', 'sample_on_pdp', 'materials_kit', 'complete_kit', 'quick_order_cnc', 'builder_continue'];
  var PROJECTS = {
    'Boat seat': 'boat_seat',
    'Boat bench (~60")': 'boat_bench',
    'Pontoon section': 'pontoon_section',
    'Door panel pair': 'door_panel_pair',
    'Auto bucket seat': 'auto_bucket_seat',
    'Restaurant booth (per side)': 'restaurant_booth',
    'Dinette / chair set': 'dinette_chair_set',
    'Aviation seat': 'aviation_seat',
    'Custom size': 'custom_size'
  };
  var MARINE_PROJECTS = ['boat_seat', 'boat_bench', 'pontoon_section'];
  var KNOWN_CART_KEYS = ['_cf_cohort', '_cf_diy_path', '_cf_diy_entry', '_cf_diy_valid'];

  function emit(name, params) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, Object.assign({ cohort: COHORT, placement: 'build_your_project' }, params || {}));
    }
  }

  function updateCartAttributes(attributes, retried) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ attributes: attributes }),
      keepalive: true
    }).then(function (response) {
      if (!response.ok) throw new Error('cart update failed');
      return response;
    }).catch(function () {
      if (!retried) return updateCartAttributes(attributes, true);
      return null;
    });
  }

  function cartSignal(pathId) {
    var safePath = PATHS.indexOf(pathId) > -1 ? pathId : 'builder_continue';
    try { window.sessionStorage.setItem('cf_diy_marine_cohort', COHORT); } catch (_) {}
    return updateCartAttributes({
      '_cf_cohort': COHORT,
      '_cf_diy_path': safePath,
      '_cf_diy_entry': 'build_your_project',
      '_cf_diy_valid': '1'
    }, false);
  }

  function clearCartSignal() {
    try { window.sessionStorage.removeItem('cf_diy_marine_cohort'); } catch (_) {}
    var cleared = {};
    KNOWN_CART_KEYS.forEach(function (key) { cleared[key] = ''; });
    cleared._cf_diy_valid = '0';
    return updateCartAttributes(cleared, false);
  }

  function trackPath(pathId) {
    if (PATHS.indexOf(pathId) === -1) return Promise.resolve();
    emit('diy_marine_path_click', { path_id: pathId });
    return cartSignal(pathId);
  }

  function trackSupport() {
    emit('diy_marine_support_click', { support_type: 'material_selection' });
    return Promise.resolve();
  }

  function trackBuilderProject(label) {
    var projectId = PROJECTS[label];
    if (!projectId || MARINE_PROJECTS.indexOf(projectId) === -1) return clearCartSignal();
    emit('builder_project_selected', { project_id: projectId });
    return cartSignal('builder_continue');
  }

  function previewAwareHref(href) {
    if (!href || href.charAt(0) === '#' || href.indexOf('://') > -1) return href;
    try {
      var current = new URL(window.location.href);
      var previewThemeId = current.searchParams.get('preview_theme_id');
      if (!previewThemeId) return href;
      var destination = new URL(href, window.location.origin);
      destination.searchParams.set('preview_theme_id', previewThemeId);
      return destination.pathname + destination.search + destination.hash;
    } catch (_) {
      return href;
    }
  }

  function preservePreviewLinks() {
    document.querySelectorAll('[data-cf-diy-path], [data-cf-diy-support]').forEach(function (link) {
      var href = link.getAttribute('href');
      var previewHref = previewAwareHref(href);
      if (previewHref && previewHref !== href) link.setAttribute('href', previewHref);
    });
  }

  function activateBuilderAnchor(href) {
    var target = document.querySelector(href);
    if (!target) return;
    if (window.history && typeof window.history.pushState === 'function') window.history.pushState(null, '', href);
    else window.location.hash = href;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    var focusTarget = target.querySelector('.cfb__title, h1, h2, [role="region"]') || target;
    if (!focusTarget.hasAttribute('tabindex')) focusTarget.setAttribute('tabindex', '-1');
    focusTarget.focus({ preventScroll: true });
  }

  preservePreviewLinks();
  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target : event.target.parentElement;
    var link = target && target.closest('[data-cf-diy-path], [data-cf-diy-support]');
    if (!link) return;
    var promise;
    if (link.hasAttribute('data-cf-diy-support')) promise = trackSupport();
    else {
      var pathId = link.getAttribute('data-cf-diy-path');
      if (!pathId) return;
      promise = trackPath(pathId);
    }
    var href = previewAwareHref(link.getAttribute('href'));
    if (!href || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
    event.preventDefault();
    Promise.race([promise, new Promise(function (resolve) { setTimeout(resolve, 650); })]).then(function () {
      if (href.charAt(0) === '#') activateBuilderAnchor(href);
      else window.location.assign(href);
    });
  });

  window.CFDiyMarine = {
    trackBuilderProject: trackBuilderProject,
    clearCartSignal: clearCartSignal
  };
})();
